import React, {Component} from 'react';
import TooieModal from "./common/TooieModal.react.js";

let i18n = require("i18next");

export default class ScreenAlertModal extends Component {
    render() {
        const bodyStyle = {margin: "0 auto", width: "80%", lineHeight: 25, marginTop: 30, marginBottom: 30};
        const divStyle = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "50px"
        };
        return (
            <TooieModal id="screenAlertModal" title={i18n.t("pos.screensize.caution")}>
                <div style={divStyle}>
                    <img src={require("../images/nz.png")}/>
                    <p style={{'marginTop': "30px"}}></p>
                </div>
            </TooieModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/ScreenAlertModal.react.js